import { useEffect, useState } from 'react';
import './notas.css';
import { Select, MenuItem,TextField, Button } from '@material-ui/core';
import {
    BookmarkBorder,
    Add,
    DeleteForever,
    Close,
    Create
} from '@material-ui/icons';
import {Alert} from '@material-ui/lab';
import { v4 as uuidv4 } from 'uuid';
import { setTaskLocalStorage,getHastags,getAllHashtags } from '../helpers/functions';
// import parse from 'html-react-parser';
import Swal from 'sweetalert2'
const Notas = ({setNewText, openSibedar, setOpenSidebar,hashtagRecient,setHashtagRecient}) => {

    const [error, setError] = useState(null);
    const [project, setProject] = useState('');
    const [ openNewProject, setOpenNewProject] = useState(false);
    const [projects, setProjects] = useState( localStorage.getItem('project_space') ?  JSON.parse(localStorage.getItem('project_space')): []);
    const [ projectSelected, setProjectSelected] = useState({
        id: '',
        name: ''
    });
    const [hashtag, setHashtag] = useState('');
    const [hashtags, setHashtags] = useState([]);
    const [showContent, setShowContent] = useState(true);
    const [ceroData, setCeroData] = useState(false);
    const [editProject, setEditProject] = useState(false);
    const [newTextProject, setNewTextProject] = useState('');
    const [oldNotes, setOldNotes] = useState( localStorage.getItem('hastags_spacegram_new') ?  JSON.parse(localStorage.getItem('hastags_spacegram_new')): []);

    useEffect(() => {
        if(oldNotes.length > 0){
            // Create a new project
            let newProject = {
                id: uuidv4(),
                name: 'Notas Guardadas'
            }
            setProjectSelected(newProject);
            let newArrayProjects = [...projects, newProject];
            setProjects(newArrayProjects);
            setProject('');
            setOpenNewProject(false);
            setShowContent(true);
            localStorage.setItem('project_space', JSON.stringify(newArrayProjects));

            // Recorrer las notas
            oldNotes.map( ({value}) => {
                // console.log(note);
                
                let HashtagNew  = {
                    id: uuidv4(),
                    name: value.replace(/<br\s*[\/]?>/gi, "\u2063\n"),
                    // nameHtml : hashtag.replace(/(?:\r\n|\r|\n)/g, "<br />"),
                    nameHtml : value.replace(/<br\s*[\/]?>/gi, " "),
                    projectId: newProject.id
                };
        
                setHashtag('');
                let newhashtags = setTaskLocalStorage(HashtagNew);
                setHashtags(newhashtags);
                localStorage.removeItem('hastags_spacegram_new');
                
            });
            
        }else{
            // console.log("No hay datos");
        }
    }, [oldNotes]);

    useEffect( () => {
        if(projects.length <= 0){
            setCeroData(true);
        }else{
            setCeroData(false);
            setProjectSelected(projects[projects.length - 1]);
        }
    }, [projects]);

    const handleChange = (e) => {
        setProject(e.target.value)
    }


    const addProject = () => {
        if(project.trim() === ''){
            setError("Ingrese un nombre de proyecto");
            setTimeout(() => {
               setError(null) 
            }, 2000);
            return;
        }

        let newProject = {
            id: uuidv4(),
            name: project
        }
        setProjectSelected(newProject);
        let newArrayProjects = [...projects, newProject];
        setProjects(newArrayProjects);
        setProject('');
        setOpenNewProject(false);
        setShowContent(true);
        localStorage.setItem('project_space', JSON.stringify(newArrayProjects));
        // console.log(newArrayProjects);

    }


    const handleChangeSelect = (e) => {
        const project = projects.filter(pro => pro.id === e.target.value);
        setProjectSelected(project[0]);
    }


    const deleteProject = (id) => {
        Swal.fire({
            title: '¿Deseas eliminar el proyecto?',
            text: "Al eliminar el proyecto se eliminarán todas tus notas asignadas al mismo",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: 'red',
            cancelButtonColor: '3085d6',
            confirmButtonText: 'Sí, eliminar proyecto',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                let newProjects = projects.filter(pro => pro.id !== id);
                let hashtags = getAllHashtags();
                let newHashtags = hashtags.filter(i => i.projectId !== id);
                setProjects(newProjects);
                setProjectSelected({
                    id: '',
                    name: ''
                })
                localStorage.setItem('project_space', JSON.stringify(newProjects));
                localStorage.setItem('hastags_space',JSON.stringify(newHashtags));
                if(newProjects.length <= 0){
                    setCeroData(true);
                    setOpenNewProject(false);
                    setEditProject(false);
                }else{
                    setCeroData(false);
                    setOpenNewProject(false);
                    setShowContent(true);
                    setEditProject(false);
                }
                Swal.fire(
                    'Eliminado!',
                    'Se eliminó con éxito.',
                    'success'
                )
            }else{
                
            }
        })
        
    }

    const updateProject = (id) => {
        let index = Number(projects.findIndex( pro => pro.id == id));
        // console.log(projects[index].name);
        // console.log(projectSelected.name);
        projects[index].name = projectSelected.name;
        setProjectSelected(projects[index]);
        localStorage.setItem('project_space', JSON.stringify(projects));
        // Swal.fire(
        //     'Actualizado!',
        //     'Se actualizo tu proyecto con éxito.',
        //     'success'
        // );
        ocultarContenido(1);
        
        // projects.map( pro => {
        //     if(pro.id === id){
        //         console.log(pro);
        //         pro.name = projectSelected.name;
        //         console.log(pro);
        //     }
        //     return pro;
        // });
    }

    const writeTask = (e) => {
        e.preventDefault();
        setHashtag(e.target.value);
    }

    const addTask = () => {
        if(hashtag.trim() == ''){
            return;
        }

        let HashtagNew  = {
            id: uuidv4(),
            name: hashtag.replace(/(?:\r\n|\r|\n)/g, "\u2063\n"),
            // nameHtml : hashtag.replace(/(?:\r\n|\r|\n)/g, "<br />"),
            nameHtml : hashtag.replace(/(?:\r\n|\r|\n)/g, " "),
            projectId: projectSelected.id
        };

        setHashtag('');
        let newhashtags = setTaskLocalStorage(HashtagNew);
        setHashtags(newhashtags);

    }

    const showText = (hashtag) => {
        setNewText(hashtag.name);
        if(window.innerWidth <= 750){
            setOpenSidebar(false);
        }else{
            setOpenSidebar(true);
        }
        
    }

    const removeHashtag = (id) => {
        let allHashtags = getAllHashtags();
        let newhashtags = allHashtags.filter(i => i.id !== id);
        setHashtags(hashtags.filter(i => i.id !== id));
        localStorage.setItem('hastags_space', JSON.stringify(newhashtags));
    }
    
    const hideSidebar = () => {
        setOpenSidebar(!openSibedar);
    }

    const handleChangeEdit = e => {
        setProjectSelected({
            id: projectSelected.id,
            name: e.target.value
        });
    }
   

    const ocultarContenido = (id) => {
        switch (id) {
            // Cero Data
            case 0:
                setCeroData(false);
                setOpenNewProject(true);
                setShowContent(false);
                break;
            // cancelar nuevo
            case 1:

                if(projects.length <= 0){
                    setCeroData(true);
                    setOpenNewProject(false);
                    setEditProject(false);
                }else{
                    setCeroData(false);
                    setOpenNewProject(false);
                    setShowContent(true);
                    setEditProject(false);
                }
                break;
            // Agregar nuevo
            case 2:
                setOpenNewProject(true);
                setShowContent(false);
                break;
            case 3: 
                setOpenNewProject(false);
                setShowContent(false);
                setEditProject(true);
                break;
            default:
                break;
        }
    }

    useEffect( () => {
        if(projectSelected.id !== ''){
            const hashtags = getHastags(projectSelected.id);
            setHashtags(hashtags);
        }
    }, [projectSelected]);

    useEffect( () => {
        if(hashtagRecient.trim() !== ''){
            if(projectSelected.id !== ''){
                const hashtags = getHastags(projectSelected.id);
                let HashtagNew  = {
                    id: uuidv4(),
                    name: hashtagRecient,
                    // nameHtml : hashtag.replace(/(?:\r\n|\r|\n)/g, "<br />"),
                    nameHtml : hashtagRecient.replace('\u2063\n', ""),
                    projectId: projectSelected.id
                };
        
                setHashtagRecient('');
                let newhashtags = setTaskLocalStorage(HashtagNew);
                setHashtags(newhashtags);
                Swal.fire({
                    icon: 'success',
                    title: 'Se añadió la nota correctamente',
                    showConfirmButton: false,
                    timer: 1500
                })

            }else{
                Swal.fire({
                    title: 'No tienes ningun proyecto seleccionado',
                    text: 'Crea tu primer proyecto y vuelve a añadir esta nota',
                    showCancelButton: true,
                    confirmButtonText: `Crear nuevo proyecto`,
                    confirmButtonColor: '#6c7cfc',
                    cancelButtonText: 'Cancelar',
                    icon: 'question'
                  }).then((result) => {
                    /* Read more about isConfirmed, isDenied below */
                    if (result.isConfirmed) {
                        ocultarContenido(0);
                    } else if (result.isDismissed) {
                        setHashtagRecient('');
                    }
                  })
                // Swal.fire(
                //     'No tienes ningun proyecto seleccionado?',
                //     'Selecciona un proyecto para añadir esta nota',
                //     'question'
                // )
            }
        }
    },[hashtagRecient])


    return ( 
        
        <div className="notas"  >
            <div style={{display:"flex", justifyContent: 'space-between', alignItems: 'center'}} >
                <h2> <BookmarkBorder /> Mis Notas</h2>
                <Close  onClick={hideSidebar} className="close-icon" />
            </div>
            {error && <Alert severity="error" style={{margin: 10}} >{error}</Alert>}
            {ceroData && (
                <>
                    <div className="cero-data">
                        <p>Para agregar hashtags o textos de uso frecuente</p>
                        <Button variant="outlined" color="primary" onClick={() => ocultarContenido(0)} >
                            CREA TU PRIMER PROYECTO
                        </Button>
                    </div>
                </>
            )}
            
            { openNewProject && (
                <div className="new-project">
                    <TextField 
                        label="Nombre del proyecto" 
                        style={{ marginBottom: 10, borderBottom: 2}} 
                        onChange={handleChange}
                        value={project}
                        variant='outlined'
                    />
                    <div className="accions">
                        <div className="actions__btns">
                            <Button variant="outlined" color="primary"  onClick={() => ocultarContenido(1)} >
                                Cancelar
                            </Button>
                            <Button variant="contained" color="primary" className="add-project" onClick={addProject} >
                                Agregar
                            </Button>
                        </div>
                        
                    </div>
                </div>
            ) }

            { editProject && (
                <div className="new-project">
                    <TextField 
                        label="Nombre del proyecto" 
                        style={{ marginBottom: 10, borderBottom: 2}} 
                        onChange={handleChangeEdit}
                        value={projectSelected.name}
                        variant='outlined'
                    />
                    <div className="accions">
                        <div className="actions__btns">
                            <Button variant="outlined" color="primary"  onClick={() => ocultarContenido(1)} >
                                Cancelar
                            </Button>
                            <Button variant="contained" color="primary" className="add-project" onClick={() => updateProject(projectSelected.id)} >
                                Actualizar
                            </Button>
                        </div>             
                    </div>

                    <Button variant="outlined" color="secondary" className="delete-project"  onClick={() => deleteProject(projectSelected.id)} >
                        Eliminar Proyecto
                    </Button>
                </div>
            ) }


            { showContent && (
                <>
                     {projects.length > 0 && (
                        <>
                            <h4>Selecciona o crea un proyecto:</h4>
                            <div className="select-new">
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={projectSelected.id}
                                    onChange={handleChangeSelect}
                                    style={{flex:1, border: 'none'}}
                                >
                                    {projects?.map( project => (
                                        <MenuItem 
                                            value={project.id} 
                                            style={{flex: 1}}
                                            key={project.id}
                                        > Proyecto: {project.name.substring(0,18)} {project.name.length >= 18 ? '...': ''}  </MenuItem>
                                        // <DeleteForever  className="delete-project" onClick={() => deleteProject(project.id)} />
                                    ))}
                                    
                                </Select>
                                {/* <p>No tienes ningun Proyecto Crea uno </p> */}
                                <Create 
                                    onClick={() => ocultarContenido(3)}
                                    className="icono"
                                />
                                <Add 
                                    onClick={() => ocultarContenido(2)}
                                    className="icono"
                                />
                            </div>
                        </>
                    )}

                    {projectSelected.id !== '' && (
                        <>
                            <div className="new-task">
                                <textarea name="" id="" cols="30" rows="10" placeholder="Escribe o pega un hashtag o texto frecuente en este proyecto…" onChange={writeTask} value={hashtag} ></textarea>
                                <Button variant="outlined" color="primary" className="add-task" onClick={addTask} >
                                    Agregar
                                </Button>

                            </div>

                            <div className="hastags-content">
                                {hashtags?.map( hashtag => (
                                    <div className="task">
                                        <p  class="incluirHastag" onClick={() =>  showText(hashtag) } >{hashtag.nameHtml.substring(0,30)} <span>...</span> </p>
                                        <DeleteForever  className="delete-notes" onClick={ () => removeHashtag(hashtag.id)} />
                                    </div>
                                ))}
                            </div>
                            
                        
                            
                        </>
                    )}
                </>
            )}
            
           

        </div>
    );
}
 
export default Notas;